/**
 * This directive handles all the interactivity between the Builder and the Virtual Location Modal
 **/
(function(){
    SUGApp.directive('signupVirtualLocation', function () {
        return {
            restrict: 'EA',
            transclude: true,
            scope: {
                virtuallocationid: '@virtuallocationid',
                onLocationSelection: '&?'
            },
            templateUrl: "/view/templates/signuplocation/signupvirtuallocation-button.html",
            replace: true,
            controller: ['$scope', 'SUGUtilities', '$modal',
                function ($scope, SUGUtilities, $modal) {

                    $scope.str = {
                        icon: {
                            virtual: 'glyphicon glyphicon-facetime-video'
                        }
                    };

                    // if virtual location id is provided, look up the info
                    $scope.virtualinfo = {
                        virtuallocationid: $scope.virtuallocationid,
                        meetingid: $scope.virtuallocationid ? ' ' : '' // this tricks the UI to understand there is a location present on initial load in case a virtuallocationid was provided
                    };

                    /* Show the modal */
                    var alreadyLoadedVirtualLocation = false;
                    $scope.displaySignupVirtualLocationModal = function () {
                        var launchSignupVirtualLocationModal = function () {
                            var templateCacheBuster = '1565966734';
                            $modal.open({
                                templateUrl: '/view/templates/signuplocation/signupvirtuallocation-modal.html?v=' + templateCacheBuster,
                                controller: dspVirtualSignupLocationModal,
                                resolve: {
                                    virtualinfo: function () {
                                        return $scope.virtualinfo;
                                    }
                                }
                            }).result.then(function (response) {
                                if (response.virtualinfo) {
                                    $scope.virtualinfo = response.virtualinfo;
                                    // if provided, execute the callback
                                    if (angular.isDefined($scope.onLocationSelection)) {
                                        $scope.onLocationSelection({
                                            locationObj: {
                                                'virtualinfo': $scope.virtualinfo
                                            }
                                        });
                                    }

                                }
                            });
                        };

                        // if there is already a virtual location, load related meta data
                        if ($scope.virtuallocationid && !alreadyLoadedVirtualLocation) {
                            SUGUtilities.APISyncCall("post", "", {
                                    'virtuallocationid': $scope.virtuallocationid
                                }, "w.getVirtualLocation", 15000)
                                .then(function (response) {
                                    if (!SUGUtilities.ajaxResultInvalid(response)) {
                                        alreadyLoadedVirtualLocation = true;
                                        var r = SUGUtilities.lowerCaseKeys(response);
                                        $scope.virtualinfo = r.data.data;
                                        launchSignupVirtualLocationModal();
                                    }
                                });
                        } else {
                            launchSignupVirtualLocationModal();
                        }
                    };

                    /* Virtual Location Modal Controller */
                    var dspVirtualSignupLocationModal = ['$scope', '$modalInstance', 'virtualinfo', 'SUGUtilities', '$q', 'errorService',
                        function ($scope, $modalInstance, virtualinfo, SUGUtilities, $q, errorService) {
                            var validateForm = function (virtualinfoform) {
                                var deferred = $q.defer();

                                var validatedForm = {
                                    virtuallocationid: virtualinfoform.virtuallocationid,
                                    meetingid: virtualinfoform.meetingid ? virtualinfoform.meetingid.toString().trim() : '', // trim and strip optional dashes
                                    type: 'Zoom' // only zoom is an option now
                                };

                                if (validatedForm.meetingid.length) {
                                    var zoomMeetingValidate = new RegExp(/^[\d]{9,11}$/); // 9-11 digits
                                    if (!zoomMeetingValidate.test(validatedForm.meetingid.replace(/\s/g, '').replace(/-/g, ''))) {
                                        deferred.reject('The meeting ID can be 9, 10, or 11 digits');
                                    }

                                } else {
                                    // if meeting id is empty, also clear the type, e.g. removing meeting
                                    validatedForm.type = '';
                                }

                                deferred.resolve(validatedForm);
                                return deferred.promise;
                            };

                            $scope.virtuallocvm = {
                                errorServiceInstance: errorService.newInstance(),
                                isProcessing: false,
                                str: {
                                    btnadd: virtualinfo.meetingid ? 'Update' : 'Add',
                                    btnremove: 'Remove',
                                    img: '/images/integrations/zoom.png',
                                    examplemeeting: 'e.g. 123-456-789'
                                },
                                showRemove: virtualinfo.meetingid ? true : false,
                                virtualinfoform: {
                                    virtuallocationid: virtualinfo.virtuallocationid,
                                    type: virtualinfo.type ? virtualinfo.type : 'Zoom',
                                    meetingid: virtualinfo.meetingid ? virtualinfo.meetingid : '',
                                },
                                save: function () {
                                    validateForm($scope.virtuallocvm.virtualinfoform).then(
                                        function (validatedForm) {
                                            $modalInstance.close({
                                                virtualinfo: validatedForm
                                            });
                                        },
                                        function (err) {
                                            $scope.virtuallocvm.errorServiceInstance.setError('zoom-meeting-id', err);
                                        }
                                    );
                                },
                                remove: function () {
                                    $modalInstance.close({
                                        virtualinfo: {
                                            virtuallocationid: virtualinfo.virtuallocationid,
                                            meetingid: '',
                                            type: ''
                                        }
                                    });
                                },
                                // handle dismissal of the modal
                                dismiss: function () {
                                    $modalInstance.dismiss(false);
                                }
                            };
                        }
                    ];

                }
            ]
        };
    });
}());